export class ScheduledRequestMigrationStatements {
  migrations = [`
    CREATE TABLE IF NOT EXISTS scheduled_request (
      id   TEXT PRIMARY KEY,
      json TEXT
    );`
  ]
}
